import {
  Card,
  CardBody,
  CardHeader,
  InputGroup,
  InputGroupText,
  Col,
  Row,
} from "reactstrap";
import InputField from "../../Utils/InputField";
import SelectField from "../../Utils/SelectField";
import { handleServiceForOffer } from "./constants/checkEmptyFields";
import { LabelText } from "../../Utils/Input";
import { useContext } from "react";
import { CreateOfferContext } from "./context";

export default function ServiceForOffer() {
  const {
    values,
    errors,
    touched,
    serviceData,
    isEdit,
    isSubscribed,
    serviceOptions,
    setServiceCode,
    setSelectedService,
    handleChange,
    setFieldValue,
  } = useContext(CreateOfferContext);

  return (
    <Row>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"serviceName"}
          className={"text-danger"}
          displayText={"Service Name"}
          classLabelName={isSubscribed ? "label-disable-color-edit-offer" : ""}
          important={"*"}
        />
        <LabelText
          htmlFor={"serviceName"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.serviceName && errors.serviceName
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.serviceName && errors.serviceName
              ? errors.serviceName
              : "Select a Service"
          }
        />
        <SelectField
          className={
            errors.serviceName && touched.serviceName ? "error-input" : "mb-3"
          }
          placeholder={" "}
          name={`serviceName`}
          labelName={"serviceName"}
          value={values.serviceName}
          isDisabled={isSubscribed ? true : false}
          handleChange={handleServiceForOffer(values, setFieldValue)}
          options={serviceOptions}
          isRVStyle={true}
        />
      </Col>
      <Col xxl={9} md={6} className="mt-5">
        <Row className="mt-1">
          {serviceData
            ?.filter(
              (service) => service?.serviceCode === values?.serviceName?.value
            )
            ?.map((value, index) => {
              return value.provisioningAttributes?.map((attribute) => (
                <Col xxl={4} md={6} key={index} className="mb-2">
                  <InputGroup>
                    <InputGroupText>{attribute.name}</InputGroupText>
                    <InputField
                      disabled={true}
                      value={attribute.default}
                      handleChange={handleChange}
                    />
                  </InputGroup>
                </Col>
              ));
            })}
        </Row>
      </Col>
    </Row>
  );
}
